import { baromoneyService } from '@/services';
import { mutationType } from './mutations';
const actionType = {
    // 필터옵션(조회기간, 라이더 상태, 항목, 검색타입, 검색어) 수정
    setFilterOption: 'setFilterOption',
    // 정렬옵션 수정
    setSortOption: 'setSortOption',
    // 페이지 사이즈 수정 - 필터옵션과는 분리
    setPageSize: 'setPageSize',
    // 페이지 넘버 수정 - 필터옵션과는 분리 (필터옵션 deep 변경시 넘버 초기화를 위함)
    setPageNumber: 'setPageNumber',
    // 라이더 바로머니 내역 조회
    getWorkerBaromoneyHistoryList: 'getWorkerBaromoneyHistoryList',
    // 바로머니 내역 초기화
    resetWorkerBaromoneyHistoryList: 'resetWorkerBaromoneyHistoryList',
    // 전체 초기화
    resetStore: 'resetStore',
};
const actions = {
    [actionType.setFilterOption]({ commit }, payload) {
        commit(mutationType.SET_FILTER_OPTION, payload);
    },
    [actionType.setSortOption]({ commit }, payload) {
        commit(mutationType.SET_SORT_OPTION, payload);
    },
    [actionType.setPageSize]({ commit }, pageSize) {
        commit(mutationType.SET_PAGE_SIZE, pageSize);
    },
    [actionType.setPageNumber]({ commit }, pageNumber) {
        commit(mutationType.SET_PAGE_NUMBER, pageNumber);
    },
    async [actionType.getWorkerBaromoneyHistoryList]({ commit, state, rootGetters }) {
        const selectedHub = rootGetters['hubSelector/getterSubscribeHubId'];
        // 선택 허브 없으면 호출 방어
        if (!selectedHub) {
            return;
        }
        const isHubSelected = rootGetters['hubSelector/getterIsSubscribeHub'];
        // 총판이면 빈값
        const hubId = isHubSelected ? selectedHub : null;
        const payload = {
            hubId,
            ...state.filterOption,
            fromDate: state.filterOption.fromDate.replaceAll('-', ''),
            toDate: state.filterOption.toDate.replaceAll('-', ''),
            pageSize: state.pageSize,
            pageNumber: state.pageNumber,
            sortOption: state.sortOption,
        };
        try {
            const response = await baromoneyService.getWorkerBaromoneyHistory(payload);
            commit(mutationType.GET_WORKER_BAROMONEY_HISTORY_LIST, response);
        }
        catch (error) {
            console.log('getWorkerBaromoneyHistoryList', error);
        }
    },
    [actionType.resetWorkerBaromoneyHistoryList]({ commit }) {
        commit(mutationType.RESET_WORKER_BAROMONEY_HISTORY_LIST);
    },
    [actionType.resetStore]({ commit }) {
        commit(mutationType.RESET_STORE);
    },
};
export default actions;
